// extracted by mini-css-extract-plugin
export default {"Icon":"📚19-10-2vCfSe"};